var _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgCircleLoginUnder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 223,
    height: 275,
    viewBox: "0 0 223 275",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 208,
    r: 181.5,
    stroke: "url(#paint0_linear_1_399)",
    strokeOpacity: 0.36,
    strokeWidth: 53
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_399",
    x1: 15,
    y1: 0,
    x2: 15,
    y2: 416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1D22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762,
    stopColor: "#2A2873"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgCircleLoginUnder);
export default __webpack_public_path__ + "static/media/bg-circle-login-under.9a7765ab394f67c3388da2e5f5f2f125.svg";
export { ForwardRef as ReactComponent };